module.exports = __webpack_public_path__ + "static/Arhimar2-d6cbfd03528138436a43f86da19baf48.jpg";